<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">Авторизация в Приват24 для бизнеса</h2>

    <privat-auth-form @after="handleAfter" />

  </div>
</template>

<script>
import privatAuthForm from '@/components/forms/privat_auth/PrivatAuthForm'

export default {
  name: 'privat-auth',
  components: { privatAuthForm },
  methods: {
    handleAfter (success) {
      if (success) {
        this.$router.push({ name: 'bank-transactions' })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// PrivatAuth.vue?5fb96250